import React from 'react';
import type { CrmNoteDTO } from '../../../server/dto/crm-note-dto.ts';
import type { ActivityFeedRecord } from '../../../server/types/customer-activity-feed-types.ts';
import { NoteTimelineItem } from './note-timeline-item.tsx';

export const ActivityFeedNoteItem = React.forwardRef<HTMLDivElement, { activity: ActivityFeedRecord }>(
    ({ activity }, ref) => {
        return <NoteTimelineItem note={activity.payload as CrmNoteDTO} ref={ref} />;
    },
);

ActivityFeedNoteItem.displayName = 'ActivityFeedNoteItem';
